import { render, staticRenderFns } from "./shoot-videos.vue?vue&type=template&id=937dc730&scoped=true&"
import script from "./shoot-videos.vue?vue&type=script&lang=ts&"
export * from "./shoot-videos.vue?vue&type=script&lang=ts&"
import style0 from "./shoot-videos.vue?vue&type=style&index=0&id=937dc730&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937dc730",
  null
  
)

export default component.exports